// TODO make a ts file
const { DefaultEventTypes } = require('./default');

const SIGNUP_TAG = 'signup';

const SignupEvents = {
  ATTEMPTED: `${SIGNUP_TAG}.${DefaultEventTypes.ATTEMPTED}`,
  SUCCESS: `${SIGNUP_TAG}.${DefaultEventTypes.SUCCESS}`,
  FAILED: `${SIGNUP_TAG}.${DefaultEventTypes.FAILED}`,
  UNKNOWN_FAILURE: `${SIGNUP_TAG}.${DefaultEventTypes.UNKNOWN_FAILURE}`,
  FAILED_ON_CREATING_USER: `${SIGNUP_TAG}.failed_on_creating_user`,
  VERIFICATION_EMAIL_SENT: `${SIGNUP_TAG}.verification_email_sent`,
  VERIFICATION_EMAIL_SEND_FAIL: `${SIGNUP_TAG}.verification_send_failed`,
  VERIFICATION_EMAIL_RESENT: `${SIGNUP_TAG}.verification_email_resent`,
  VERIFICATION_EMAIL_RESEND_FAIL: `${SIGNUP_TAG}.verification_resend_failed`,
};

module.exports = { SIGNUP_TAG, SignupEvents };
